import { Link } from 'react-router-dom';

const examCategories = [
  {
    id: 'cpa',
    icon: 'ri-bank-card-line',
    title: 'CPA 注册会计师',
    englishTitle: 'CPA Exam',
    desc: '财务会计、审计、税法、经济法全科精讲，通关率行业领先',
    color: 'from-amber-500 to-orange-500',
    bgLight: 'bg-amber-50',
    textColor: 'text-amber-700',
    borderColor: 'border-amber-200',
    stats: '11,230人在学',
    tag: '职业资格',
    courses: 6,
    link: '/videos',
    image: 'https://public.readdy.ai/ai/img_res/892e385ab503a16ab9cd9871c5583d62.jpg',
  },
  {
    id: 'nurse',
    icon: 'ri-heart-pulse-line',
    title: '护士执照考试',
    englishTitle: 'Nurse Licensing Exam',
    desc: '基础护理、内外科护理、妇儿护理全面覆盖，助你顺利持证上岗',
    color: 'from-rose-500 to-pink-500',
    bgLight: 'bg-rose-50',
    textColor: 'text-rose-700',
    borderColor: 'border-rose-200',
    stats: '35,300人在学',
    tag: '医疗卫生',
    courses: 8,
    link: '/videos',
    image: 'https://readdy.ai/api/search-image?query=nursing%20exam%20preparation%2C%20medical%20textbooks%20and%20stethoscope%20on%20white%20desk%2C%20healthcare%20education%20setting%2C%20clean%20rose%20pink%20tones%2C%20professional%20medical%20atmosphere&width=600&height=360&seq=exam002&orientation=landscape',
  },
  {
    id: 'cet',
    icon: 'ri-translate-2',
    title: '英语四级 & 六级',
    englishTitle: 'CET-4 & CET-6',
    desc: '听力、阅读、写作、翻译四大题型全攻略，四六级一次通过',
    color: 'from-green-500 to-teal-500',
    bgLight: 'bg-green-50',
    textColor: 'text-green-700',
    borderColor: 'border-green-200',
    stats: '63,480人在学',
    tag: '英语考试',
    courses: 12,
    link: '/videos',
    image: 'https://readdy.ai/api/search-image?query=CET%20English%20exam%20preparation%2C%20English%20textbooks%20and%20vocabulary%20cards%20on%20bright%20desk%2C%20university%20student%20study%20setting%2C%20fresh%20green%20tones%2C%20clean%20educational%20atmosphere&width=600&height=360&seq=exam003&orientation=landscape',
  },
  {
    id: 'doctor',
    icon: 'ri-stethoscope-line',
    title: '执业医师考试',
    englishTitle: 'Licensed Doctor Exam',
    desc: '临床、中医、口腔、公卫全科系统精讲，助你成为合格执业医师',
    color: 'from-cyan-500 to-sky-500',
    bgLight: 'bg-cyan-50',
    textColor: 'text-cyan-700',
    borderColor: 'border-cyan-200',
    stats: '23,320人在学',
    tag: '医疗卫生',
    courses: 10,
    link: '/videos',
    image: 'https://readdy.ai/api/search-image?query=licensed%20doctor%20exam%20preparation%2C%20medical%20anatomy%20textbooks%20and%20clinical%20notes%20on%20hospital%20desk%2C%20physician%20education%20setting%2C%20clean%20blue%20tones%2C%20professional%20medical%20atmosphere&width=600&height=360&seq=exam004&orientation=landscape',
  },
  {
    id: 'law',
    icon: 'ri-scales-3-line',
    title: '法律职业资格',
    englishTitle: 'Bar Exam (Legal Qualification)',
    desc: '民法、刑法、行政法、诉讼法全面覆盖，法考一次通关',
    color: 'from-violet-500 to-purple-500',
    bgLight: 'bg-violet-50',
    textColor: 'text-violet-700',
    borderColor: 'border-violet-200',
    stats: '28,010人在学',
    tag: '法律资格',
    courses: 9,
    link: '/videos',
    image: 'https://readdy.ai/api/search-image?query=law%20bar%20exam%20preparation%2C%20legal%20books%20and%20scales%20of%20justice%20on%20wooden%20desk%2C%20law%20school%20study%20setting%2C%20elegant%20purple%20tones%2C%20serious%20academic%20legal%20atmosphere&width=600&height=360&seq=exam005&orientation=landscape',
  },
];

export default function ProfessionalExamSection() {
  return (
    <section className="py-20 bg-[#faf9f7]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 bg-gray-900 rounded-full px-4 py-1.5 mb-5">
            <i className="ri-award-fill text-amber-400 text-sm"></i>
            <span className="text-white text-xs font-semibold tracking-wide">职业资格考试专区</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-3">
            从学生到职场精英，<br className="hidden md:block" />
            <span className="text-red-600">一站式备考解决方案</span>
          </h2>
          <p className="text-gray-500 text-sm max-w-xl mx-auto leading-relaxed">
            涵盖 CPA、护士执照、英语四六级、执业医师、法律职业资格五大热门考试，
            名师精讲 + 真题解析 + 冲刺押题，助你高效通关。
          </p>
        </div>

        {/* Top featured exam — CET (most popular) */}
        <div className="mb-6">
          <Link
            to="/videos"
            className="group relative rounded-3xl overflow-hidden flex flex-col md:flex-row h-auto md:h-64 cursor-pointer block"
          >
            <div className="absolute inset-0">
              <img
                src={examCategories[2].image}
                alt="英语四六级"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-green-900/85 via-green-800/60 to-transparent"></div>
            </div>
            <div className="relative z-10 p-8 md:p-10 flex flex-col justify-center max-w-lg">
              <div className="flex items-center gap-2 mb-3">
                <span className="bg-green-400/20 border border-green-300/40 text-green-200 text-xs px-3 py-1 rounded-full font-medium">
                  最热门考试
                </span>
                <span className="text-green-300 text-xs">{examCategories[2].stats}</span>
              </div>
              <h3 className="text-2xl md:text-3xl font-black text-white mb-2">
                英语四级 &amp; 六级
              </h3>
              <p className="text-white/70 text-xs mb-1 font-medium tracking-wider">CET-4 &amp; CET-6</p>
              <p className="text-white/80 text-sm leading-relaxed mb-5">{examCategories[2].desc}</p>
              <div className="flex items-center gap-3">
                <span className="px-5 py-2.5 bg-white text-green-700 font-bold text-sm rounded-full group-hover:bg-green-50 transition-colors whitespace-nowrap">
                  立即备考 <i className="ri-arrow-right-line ml-1"></i>
                </span>
                <span className="text-white/60 text-xs">{examCategories[2].courses} 门精品课程</span>
              </div>
            </div>
          </Link>
        </div>

        {/* 4 exam cards grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-8">
          {[examCategories[0], examCategories[1], examCategories[3], examCategories[4]].map((exam) => (
            <Link
              key={exam.id}
              to={exam.link}
              className="group bg-white rounded-2xl overflow-hidden hover:scale-[1.02] transition-all duration-300 cursor-pointer block"
            >
              {/* Image */}
              <div className="relative h-36 overflow-hidden">
                <img
                  src={exam.image}
                  alt={exam.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className={`absolute inset-0 bg-gradient-to-t from-black/70 to-transparent`}></div>
                <div className="absolute top-3 left-3">
                  <span className={`text-[10px] px-2 py-0.5 rounded-full font-semibold ${exam.bgLight} ${exam.textColor}`}>
                    {exam.tag}
                  </span>
                </div>
                <div className="absolute bottom-3 left-3 flex items-center gap-1.5">
                  <div className={`w-6 h-6 flex items-center justify-center bg-gradient-to-br ${exam.color} rounded-lg`}>
                    <i className={`${exam.icon} text-white text-xs`}></i>
                  </div>
                  <span className="text-white text-xs font-semibold">{exam.englishTitle}</span>
                </div>
              </div>
              {/* Content */}
              <div className="p-4">
                <h3 className="font-black text-gray-900 text-sm mb-1.5 group-hover:text-red-600 transition-colors">
                  {exam.title}
                </h3>
                <p className="text-gray-500 text-[11px] leading-relaxed mb-3 line-clamp-2">{exam.desc}</p>
                <div className="flex items-center justify-between">
                  <span className="text-gray-400 text-[10px]">
                    <i className="ri-user-line mr-0.5"></i>{exam.stats}
                  </span>
                  <span className={`text-[10px] font-semibold ${exam.textColor} flex items-center gap-0.5`}>
                    {exam.courses}门课程 <i className="ri-arrow-right-s-line"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>


        {/* View all CTA */}
        <div className="flex justify-center">
          <Link
            to="/videos"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-gray-900 hover:bg-gray-800 text-white font-semibold rounded-full transition-all cursor-pointer whitespace-nowrap group"
          >
            <i className="ri-apps-line text-amber-400"></i>
            查看全部考试课程
            <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
